import { render, staticRenderFns } from "./AddNewPowerGuardQuery.vue?vue&type=template&id=3fe594ca&"
import script from "./AddNewPowerGuardQuery.vue?vue&type=script&lang=js&"
export * from "./AddNewPowerGuardQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports